"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.array.find");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
var echarts = _interopRequireWildcard(require("echarts"));
var _comment = _interopRequireDefault(require("../components/comment.vue"));
var _index = require("@/utils/index");
var _homeReport = require("@/http/interface/sfe/homeReport");
var _methods = require("@/components/Store/SalesKPIRecord/methods");
var _headerFilter = _interopRequireDefault(require("../components/headerFilter.vue"));
var _AssignTasks = _interopRequireDefault(require("@/components/AssignTasks"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** services */

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var mapObj = new Map();
mapObj.set('1', curDateTree.month);
mapObj.set('2', curDateTree.quarter);
mapObj.set('3', curDateTree.year);
var _default = exports.default = {
  components: {
    Commment: _comment.default,
    HeaderFilter: _headerFilter.default,
    AssignTasks: _AssignTasks.default
  },
  data: function data() {
    return {
      headerLabers: ['timeType', 'time'],
      from: 'prodSize',
      salesForm: {
        type: '',
        value: ''
      },
      saleEchartsData: {
        // 折线图
        chartNameList: [],
        series: []
      },
      showCommentDialog: false,
      currentRow: {},
      activeTab: '3',
      // 表格的tab
      asm_table: {
        loading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        data: [],
        selected: [],
        defaultSort: {
          prop: 'actualCount',
          order: 'descending'
        }
      },
      sr_table: {
        loading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        data: [],
        selected: [],
        defaultSort: {
          prop: 'actualCount',
          order: 'descending'
        }
      },
      sp_table: {
        loading: false,
        currPage: 1,
        limit: 10,
        total: 0,
        data: [],
        selected: [],
        defaultSort: {
          prop: 'actualCount',
          order: 'descending'
        }
      },
      mixActiveTab: '18',
      mixData_17: {},
      // Mix_17
      mixData_18: {},
      // Mix_18
      mixData_19: {},
      // Mix_18
      mixData_20: {} // Mix_18
    };
  },
  computed: {
    isShowASMTable: function isShowASMTable() {
      // 默认不显示
      var result = false;
      var functions = this.$store.getters.functions || {};
      var homeType = this.$store.getters.homeType || {};
      if (functions[homeType] && Array.isArray(functions[homeType]) && functions[homeType].includes('ASM_SORT')) {
        result = true;
      }
      return result;
    },
    mixActiveTabData: function mixActiveTabData() {
      if (this.mixActiveTab === '17') {
        return this.mixData_17;
      } else if (this.mixActiveTab === '18') {
        return this.mixData_18;
      } else if (this.mixActiveTab === '19') {
        return this.mixData_19;
      } else if (this.mixActiveTab === '20') {
        return this.mixData_20;
      } else {
        return [];
      }
    },
    findValueByType: function findValueByType() {
      return function (type) {
        return mapObj.get(type) || '';
      };
    }
  },
  watch: {
    mixActiveTab: function mixActiveTab(val, oldVal) {
      if (val !== oldVal) {
        // 刷新折线图和table
        this.fetchEchartsData();
        this.fetchTablePageOne(this.activeTab);
      }
    },
    'salesForm.value': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (oldVal && val !== oldVal) {
          // 刷新
          this.initPage();
        }
      }
    },
    'salesForm.type': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (oldVal && val !== oldVal) {
          var value = this.findValueByType(val);
          this.salesForm.value = value;
          this.mixActiveTab = '18';
        }
      }
    }
  },
  created: function created() {
    this.salesForm = (0, _objectSpread2.default)({}, this.$route.query);
  },
  mounted: function mounted() {
    // echart初始化
    this.SALESChat = echarts.init(document.getElementById('id_mixLineEchart'));
    // 初始化
    this.initPage();
  },
  methods: {
    toSrDetailsPage: function toSrDetailsPage(row) {
      this.$router.push({
        path: '/srDetails',
        query: {
          srEmpNo: row.srEmpNo
        }
      });
    },
    typeChange: function typeChange(val) {
      this.salesForm.type = val;
      var value = this.findValueByType(val);
      this.salesForm.value = value;
      // 刷新
      this.initPage();
    },
    initPage: function initPage() {
      // MIX
      this.fetchMixData();
      // 请求数据
      this.fetchEchartsData();
      // 请求第一个表格数据
      this.fetchTablePageOne(this.activeTab);
    },
    fetchTablePageOne: function fetchTablePageOne(activeTab) {
      // tab变化，请求第一页
      if (activeTab === '1') {
        this.asm_table.currPage = 1;
        this.fetchAsmList();
      } else if (activeTab === '2') {
        this.sr_table.currPage = 1;
        this.fetchSrList();
      } else if (activeTab === '3') {
        this.sp_table.currPage = 1;
        this.fetchSpList();
      }
    },
    fetchMixData: function fetchMixData() {
      var _this = this;
      (0, _homeReport.getMixData)(this.salesForm).then(function (res) {
        var mixData = res.data || [];
        var mixData_17 = mixData.find(function (item) {
          return item.title === '17+';
        });
        var mixData_18 = mixData.find(function (item) {
          return item.title === '18+';
        });
        var mixData_19 = mixData.find(function (item) {
          return item.title === '19+';
        });
        var mixData_20 = mixData.find(function (item) {
          return item.title === '20+';
        });
        _this.mixData_17 = mixData_17 || {};
        _this.mixData_18 = mixData_18 || {};
        _this.mixData_19 = mixData_19 || {};
        _this.mixData_20 = mixData_20 || {};
      });
    },
    fetchEchartsData: function fetchEchartsData() {
      var _this2 = this;
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
        prodSize: "".concat(this.mixActiveTab, "+")
      });
      (0, _homeReport.getSaleDetailLineChart)(params, this.from).then(function (res) {
        _this2.saleEchartsData = {
          chartNameList: res.data.chartNameList || [],
          series: res.data.series || []
        };
        (0, _methods.drawLineSales)(_this2.SALESChat, _this2.salesForm, _this2.saleEchartsData);
      });
    },
    fetchAsmList: function fetchAsmList() {
      var _this3 = this;
      var params = {
        currPage: this.asm_table.currPage,
        limit: this.asm_table.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
          orderByField: this.asm_table.defaultSort.prop,
          ascOrDesc: this.asm_table.defaultSort.order === 'ascending' ? 'asc' : 'desc',
          prodSize: "".concat(this.mixActiveTab, "+")
        })
      };
      this.asm_table.loading = true;
      (0, _homeReport.getSaleASMList)(params, this.from).then(function (res) {
        _this3.asm_table.loading = false;
        _this3.asm_table.data = res.data.items || [];
        _this3.asm_table.total = res.data.totalCount;
      }).catch(function () {
        _this3.asm_table.loading = false;
      });
    },
    fetchSrList: function fetchSrList() {
      var _this4 = this;
      var params = {
        currPage: this.sr_table.currPage,
        limit: this.sr_table.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
          orderByField: this.sr_table.defaultSort.prop,
          ascOrDesc: this.sr_table.defaultSort.order === 'ascending' ? 'asc' : 'desc',
          prodSize: "".concat(this.mixActiveTab, "+")
        })
      };
      this.sr_table.loading = true;
      (0, _homeReport.getSaleSRList)(params, this.from).then(function (res) {
        _this4.sr_table.loading = false;
        _this4.sr_table.data = res.data.items || [];
        _this4.sr_table.total = res.data.totalCount;
      }).catch(function () {
        _this4.sr_table.loading = false;
      });
    },
    fetchSpList: function fetchSpList() {
      var _this5 = this;
      var params = {
        currPage: this.sp_table.currPage,
        limit: this.sp_table.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.salesForm), {}, {
          orderByField: this.sp_table.defaultSort.prop,
          ascOrDesc: this.sp_table.defaultSort.order === 'ascending' ? 'asc' : 'desc',
          prodSize: this.mixActiveTab
        })
      };
      this.sp_table.loading = true;
      (0, _homeReport.getSaleSPList)(params, this.from).then(function (res) {
        _this5.sp_table.loading = false;
        _this5.sp_table.data = res.data.items || [];
        _this5.sp_table.total = res.data.totalCount;
      }).catch(function () {
        _this5.sp_table.loading = false;
      });
    },
    selectionChange: function selectionChange(val, tableName) {
      this[tableName].selected = val;
    },
    sortAsmTable: function sortAsmTable(_ref) {
      var column = _ref.column,
        prop = _ref.prop,
        order = _ref.order;
      if (!order) {
        var newOrder = this.asm_table.defaultSort.order === 'descending' ? 'ascending' : 'descending';
        this.asm_table.defaultSort = {
          prop: 'actualCount',
          order: newOrder
        };
        this.$refs.asmMultipleTable.sort('actualCount', newOrder);
      } else {
        this.asm_table.defaultSort = {
          prop: prop,
          order: order
        };
        this.fetchTablePageOne(this.activeTab);
      }
    },
    sortSrTable: function sortSrTable(_ref2) {
      var column = _ref2.column,
        prop = _ref2.prop,
        order = _ref2.order;
      if (!order) {
        var newOrder = this.sr_table.defaultSort.order === 'descending' ? 'ascending' : 'descending';
        this.sr_table.defaultSort = {
          prop: 'actualCount',
          order: newOrder
        };
        this.$refs.srMultipleTable.sort('actualCount', newOrder);
      } else {
        this.sr_table.defaultSort = {
          prop: prop,
          order: order
        };
        this.fetchTablePageOne(this.activeTab);
      }
    },
    sortSpTable: function sortSpTable(_ref3) {
      var column = _ref3.column,
        prop = _ref3.prop,
        order = _ref3.order;
      if (!order) {
        var newOrder = this.sp_table.defaultSort.order === 'descending' ? 'ascending' : 'descending';
        this.sp_table.defaultSort = {
          prop: 'actualCount',
          order: newOrder
        };
        this.$refs.spMultipleTable.sort('actualCount', newOrder);
      } else {
        this.sp_table.defaultSort = {
          prop: prop,
          order: order
        };
        this.fetchTablePageOne(this.activeTab);
      }
    },
    addCommentByBatch: function addCommentByBatch(tableName, nameKey) {
      this.currentRow = {
        selected: this[tableName].selected,
        nameKey: nameKey,
        params: {
          dateType: this.salesForm.type,
          dateValue: this.salesForm.value
        }
      };
      this.showCommentDialog = true;
    },
    addCommentByRow: function addCommentByRow(row, apiKey, rowKey) {
      var _this6 = this;
      var params = (0, _defineProperty2.default)({}, apiKey, row[rowKey] || '');
      (0, _homeReport.getCommentOrgBiz)(params).then(function (res) {
        _this6.currentRow = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, row), {}, {
          orgBiz: res.data || [],
          params: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, params), {}, {
            dateType: _this6.salesForm.type,
            dateValue: _this6.salesForm.value
          })
        });
      });
      this.showCommentDialog = true;
    },
    submitCommentDialog: function submitCommentDialog(form) {
      if (this.currentRow.hasOwnProperty('selected')) {
        this.submitCommentByBatch(form);
      } else {
        this.submitCommentByRow(form);
      }
    },
    submitCommentByRow: function submitCommentByRow(form) {
      var _this7 = this;
      var empNoList = [].concat((0, _toConsumableArray2.default)(form.asm), (0, _toConsumableArray2.default)(form.sr));
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        businessType: 1,
        actionLikes: form.actionLikes,
        actionContent: "".concat(form.content, " ").concat(form.desc)
      }, this.currentRow.params), {}, {
        prodSize: "".concat(this.mixActiveTab, "+"),
        originType: 'srDetail',
        empNoList: empNoList
      });
      if (this.activeTab === '1') {
        params.asmEmpNo = params.smEmpNo;
        delete params.smEmpNo;
      }
      (0, _homeReport.getCommentSendSingle)(params).then(function (res) {
        _this7.$message.success(_this7.$t('dashboard.commentSuccess'));
        _this7.closeCommentDialog();
      });
    },
    submitCommentByBatch: function submitCommentByBatch(form) {
      var _this8 = this;
      var p = {};
      if (this.activeTab === '1') {
        p.asmEmpNoList = this.currentRow.selected.map(function (item) {
          return item.asmEmpNo;
        });
      } else if (this.activeTab === '2') {
        p.srEmpNoList = this.currentRow.selected.map(function (item) {
          return item.srEmpNo;
        });
      } else if (this.activeTab === '3') {
        p.spSapIdList = this.currentRow.selected.map(function (item) {
          return item.spId;
        });
      }
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({
        businessType: 1,
        actionLikes: form.actionLikes,
        actionContent: "".concat(form.content, " ").concat(form.desc)
      }, this.currentRow.params), {}, {
        prodSize: "".concat(this.mixActiveTab, "+"),
        originType: 'srDetail'
      }, p);
      (0, _homeReport.getCommentSendBatch)(params).then(function (res) {
        _this8.$message.success(_this8.$t('dashboard.commentSuccess'));
        _this8.closeCommentDialog();
      });
    },
    closeCommentDialog: function closeCommentDialog() {
      this.showCommentDialog = false;
      this.currentRow = {};
      // 刷新界面
      if (this.activeTab === '1') {
        this.fetchAsmList();
      } else if (this.activeTab === '2') {
        this.fetchSrList();
      } else if (this.activeTab === '3') {
        this.fetchSpList();
      }
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    },
    // 分配任务
    assignTasks: function assignTasks(SRInfo) {
      var param = {
        srEmpName: SRInfo.srEmpNoName,
        srEmpNo: SRInfo.srEmpNo
      };
      this.$refs.AssignTasks.showModel(param, 'srDetail');
    }
  }
};